import Jumbotron from '@/components/ui/box/Jumbotron';
import JumbotronDescription from '@/components/ui/box/JumbotronDescription.tsx';
import JumbotronPanel from '@/components/ui/box/JumbotronPanel';
import JumbotronTitle from '@/components/ui/box/JumbotronTitle.tsx';

type Props = {
  type: 'notContracted' | 'notAllowed';
};

const AbsencesRestricted: React.FC<Props> = ({ type }) => (
  <Jumbotron>
    <JumbotronPanel>
      <JumbotronTitle>欠席連絡機能を利用できません</JumbotronTitle>
      <JumbotronDescription>
        {type === 'notContracted'
          ? '契約手続きが未完了のため利用できません。学校にお問い合わせください。'
          : '所属されている学校では欠席連絡機能を使用しない設定になっています。'}
      </JumbotronDescription>
    </JumbotronPanel>
  </Jumbotron>
);

export default AbsencesRestricted;
